export enum AccountTypes {
  Admin,
  SecurityOfficer,
}
